import { Helmet } from "react-helmet";
import Header from "../../../../Components/Header";
import PurchaseForm from "./PurchaseForm";

const ViewPutAway = () => {
  return (
    <div className="d-flex flex-column" style={{ minHeight: '100vh' }}>
      <Helmet>
				<title>Putaway - View</title>
			</Helmet>
      <Header />
      <div className="container-fluid maindiv d-flex flex-column" style={{flexGrow:'1'}}>
        <PurchaseForm />
      </div>
    </div>
  );
};

export default ViewPutAway;
